import { SetStateAction, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  IEvent,
  Input,
  IResponse,
  MenuWrapper,
  Select,
  SelectCalendar,
} from '../../../component';
import {
  setMinMaxAreaLocalFilters,
  setMinMaxDateLocalFilters,
} from '../charts/redux/charts.actions';
import { setDisplayCharts } from '../redux/dashboardActions';
import {
  InputIntervalEvent,
  MarketCycleFilters,
  MarketCycleInputIntervals,
  MarketCycleInputs,
  MinMaxValue,
  MultiSelectButtonsProps,
  NameValuePair,
  RealtyType,
  TwoStateButton,
  Validation,
  ValidationMessages,
} from '../types';
import './marketCycle.scss';
import {
  clearFiltersMarketCycle,
  updateMarketCycleFilters,
  updateMarketCycleFiltersInputIntervals,
} from './redux/marketCycle.actions';
import {
  handleInputsIntervals,
  handlePriceInputs,
  searchMarketCycle,
} from './redux/marketCycle.controller';
interface MarketCycleProps {
  closeModalAction: () => void;
}

const MarketCycle: React.FC<MarketCycleProps> = ({ closeModalAction }) => {
  const [validation, setValidation] = useState<Partial<Validation>>({
    timeframemin: false,
  });
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);
  const marketCycleFilters: MarketCycleFilters = useSelector(
    (state: any) => state.marketCycleState.marketCycleFilters
  );
  const dispatch = useDispatch();
  const { bedrooms, suites, garages } = marketCycleFilters;
  const handleSubmit = () => {
    dispatch([searchMarketCycle(marketCycleFilters), closeModalAction()]);
  };
  const handleClearFilters = () => {
    setValidation({
      timeframemin: false,
    });
    dispatch(clearFiltersMarketCycle());
  };

  useEffect(() => {
    return () => {
      dispatch(setDisplayCharts(null));
    };
  }, []);

  return (
    <MenuWrapper
      title={nls.titles.marketCycle}
      market="Transactions"
      submitButtonLabel={nls.toApply}
      // clearButtonLabel={nls.clearFilters}
      submitAction={handleSubmit}
      // clearAction={handleClearFilters}
    >
      <div className="market-cycle">
        {/* COMENTADO ATÉ A IMPLEMTAÇÃO DOS FILTROS NO BACKEND */}
        {/* <SelectRealtyType />
        <InputIntervals validation={validation} setValidation={setValidation} />
        <MultiSelectButtons buttonsData={bedrooms} arrayName="bedrooms" />
        <MultiSelectButtons buttonsData={suites} arrayName="suites" />
        <MultiSelectButtons buttonsData={garages} arrayName="garages" /> */}
      </div>
    </MenuWrapper>
  );
};

const SelectRealtyType: React.FC = () => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);
  const dispatch = useDispatch();
  const {
    marketCycleFiltersOptions,
    marketCycleFilters,
    marketCycleTimeframe,
  } = useSelector((state: any) => state.marketCycleState);
  const realtyType = marketCycleFilters.realtyType as RealtyType;
  const handleClickSelect = (e: NameValuePair, arrayName: string) => {
    const payload = {
      name: arrayName,
      value: e.value,
    };
    dispatch(updateMarketCycleFilters(payload));
  };

  return (
    <div className="market-cycle__inputs-container">
      <div className="market-cycle__inputs-container__label-container">
        <span className="label" style={{ marginTop: 8 }}>
          {nls.labels.realtyType}
        </span>
      </div>
      <div>
        <Select
          options={marketCycleFiltersOptions?.realtyTypes as RealtyType[]}
          label=""
          cy="RealtyTypeMarketCycle"
          action={(e) => handleClickSelect(e, 'realtyType')}
          name="realtyType"
          selected={realtyType ? realtyType : 'Apartamento'}
          style={{ color: '#FFF' }}
        />
      </div>
    </div>
  );
};

type InputIntervalProps = {
  validation: Partial<Validation>;
  setValidation: React.Dispatch<SetStateAction<Partial<Validation>>>;
};

const InputIntervals: React.FC<InputIntervalProps> = ({
  validation,
  setValidation,
}) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);
  const { marketCycleFilters } = useSelector(
    (state: any) => state.marketCycleState
  );
  const inputIntervals: MarketCycleInputIntervals =
    marketCycleFilters.inputIntervals;
  const inputPatterns: MarketCycleInputs = {
    timeframe: {
      pattern: 'number',
      erro: validation,
      message:
        validation.timeframe === 'Preencha os campos'
          ? nls.errorMessages.minBiggerThanMax
          : '',
    },
    timeframemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.timeframemin === 'biggerThanMax'
          ? nls.errorMessages.minBiggerThanMax
          : '',
    },
    timeframemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.timeframemax === 'smallerThanMin'
          ? nls.errorMessages.maxSmallerThanMin
          : '',
    },
    privateAreaIntervalmin: {
      pattern: '',
      erro: validation,
      message:
        validation.privateAreaIntervalmin === 'biggerThanMax'
          ? nls.errorMessages.minBiggerThanMax
          : '',
    },
    privateAreaIntervalmax: {
      pattern: '',
      erro: validation,
      message:
        validation.privateAreaIntervalmax === 'smallerThanMin'
          ? nls.errorMessages.maxSmallerThanMin
          : '',
    },
    unitPricemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.unitPricemin === 'biggerThanMax'
          ? nls.errorMessages.minBiggerThanMax
          : '',
    },
    unitPricemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.unitPricemax === 'smallerThanMin'
          ? nls.errorMessages.maxSmallerThanMin
          : '',
    },
    pricePerSquareMtmin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.pricePerSquareMtmin === 'biggerThanMax'
          ? nls.errorMessages.minBiggerThanMax
          : '',
    },
    pricePerSquareMtmax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.pricePerSquareMtmax === 'smallerThanMin'
          ? nls.errorMessages.maxSmallerThanMin
          : '',
    },
    realtyAgemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.realtyAgemin === 'biggerThanMax'
          ? nls.errorMessages.minBiggerThanMax
          : '',
    },
    realtyAgemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.realtyAgemax === 'smallerThanMin'
          ? nls.errorMessages.maxSmallerThanMin
          : '',
    },
  };
  type PickByValue<T, V> = Pick<
    T,
    { [K in keyof T]: T[K] extends V ? K : never }[keyof T]
  >;

  type Entries<T> = {
    [K in keyof T]: [keyof PickByValue<T, T[K]>, T[K]];
  }[keyof T][];

  return (
    <>
      {(
        Object.entries(inputIntervals) as Entries<MarketCycleInputIntervals>
      ).map((el, index) => {
        const name = el[0] as keyof MarketCycleInputIntervals;
        const value = el[1] as MinMaxValue<string>;
        return (
          <div
            className="market-cycle__inputs-container"
            key={`input-section-container-${index}`}
          >
            <div className="market-cycle__inputs-container__label-container row-container">
              <span data-cy={`ContainerTitle${name}`} className="label">
                {nls.labels[name]}
              </span>
              <span data-cy={`ContainerTitle${name}`} className="label">
                {name === 'timeframe' ? '' : '(opcional)'}
              </span>
            </div>

            {name === 'timeframe' ? (
              <TimeframeInputs
                inputPatterns={inputPatterns}
                name={name}
                value={value}
                validation={validation}
                setValidation={setValidation}
              />
            ) : (
              <NumericInputs
                inputPatterns={inputPatterns}
                name={name}
                value={value}
                validation={validation}
                setValidation={setValidation}
                tuple={el}
              />
            )}
          </div>
        );
      })}
    </>
  );
};

type InputIntervalsProps = {
  inputPatterns: MarketCycleInputs;
  name: keyof MarketCycleInputIntervals;
  value: MinMaxValue<string>;
  validation: Partial<Validation>;
  setValidation: React.Dispatch<SetStateAction<Partial<Validation>>>;
};

type InputIntervalTuple = [
  keyof MarketCycleInputIntervals,
  MinMaxValue<string>
];

type NumericInputIntervalsProps = InputIntervalsProps & {
  tuple: InputIntervalTuple;
};

const TimeframeInputs: React.FC<InputIntervalsProps> = ({
  inputPatterns,
  name,
  value,
  validation,
  setValidation,
}) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const { marketCycleTimeframe } = useSelector(
    (state: any) => state.marketCycleState
  );
  const [startDate, setStartDate] = useState<string>(
    `00/${marketCycleTimeframe[0]}`
  );
  const [endDate, setEndDate] = useState<string>(
    `12/${marketCycleTimeframe.at(-1)}`
  );
  useEffect(() => {
    setStartDate(`00/${marketCycleTimeframe[0]}`);
    setEndDate(`12/${marketCycleTimeframe.at(-1)}`);
  }, [marketCycleTimeframe]);
  const nls = require(`./nls/${preference.language.id}.json`);
  const dispatch = useDispatch();
  const handleInputCalendar = (e: NameValuePair) => {
    const newMinDate = e.value.min.length > 0 ? e.value.min : 0;
    const newMaxDate = e.value.max.length > 0 ? e.value.max : 0;
    if (e.value.min && e.value.max) {
      if (dataValidacao(e.value.min) <= dataValidacao(e.value.max)) {
        setValidation({ ...validation, [e.name]: false });
      } else {
        setValidation({ ...validation, [e.name]: 'Final menor que inicial' });
      }
    } else {
      if (e.value.min === '' && e.value.max === '') {
        setValidation({ ...validation, [e.name]: false });
      } else {
        setValidation({ ...validation, [e.name]: 'Preencha os campos' });
      }
    }
    dispatch([
      setMinMaxDateLocalFilters({ max: newMaxDate, min: newMinDate }),
      updateMarketCycleFiltersInputIntervals(e),
    ]);
  };
  const dataValidacao = (e: any) => {
    const val = e.split('-');
    return Number(`${val[1]}${val[0]}`);
  };

  return (
    <section className="market-cycle__calendars-section">
      <div className="row-container calendar-inputs-container">
        <div className="calendar-left-selector">
          <SelectCalendar
            name={name}
            type="yearMonth"
            placeholder={nls.initial}
            action={(e: InputIntervalEvent<string>) => {
              handleInputCalendar({
                name: e.name,
                value: { ...value, min: e.value },
              });
            }}
            selected={value.min}
            dataInicio={startDate}
            dataFim={endDate}
            cy="min"
            required={inputPatterns[`${name}min` as keyof MarketCycleInputs]}
          />
        </div>
        <div className="calendar-right-selector">
          <SelectCalendar
            name={name}
            type="yearMonth"
            placeholder={nls.final}
            action={(e: InputIntervalEvent<string>) => {
              handleInputCalendar({
                name: e.name,
                value: { ...value, max: e.value },
              });
            }}
            selected={value.max}
            dataInicio={startDate}
            dataFim={endDate}
            cy="max"
            required={inputPatterns[`${name}max` as keyof MarketCycleInputs]}
          />
        </div>
      </div>
      {validation?.[name] ? (
        <span
          className="campo-obrigatorio-erro"
          data-cy="MandatorySelectCalendaraFieldSpan"
        >
          {validation[name]}
        </span>
      ) : null}
    </section>
  );
};

const NumericInputs: React.FC<NumericInputIntervalsProps> = ({
  inputPatterns,
  name,
  value,
  validation,
  setValidation,
  tuple,
}) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);
  const dispatch = useDispatch();
  const { minMaxArea } = useSelector(
    (state: any) => state.chartsState.localFilters
  );
  const unmaskValue = (el: string): string => {
    let returnString = el;
    if (el.includes('R$')) {
      returnString = el.split('R$')[1];
    }
    if (el.includes('.')) returnString = returnString.replaceAll('.', '');
    if (el.includes(',')) returnString = returnString.replace(',', '.');
    return returnString;
  };
  const replaceCurrencyIfValid = (
    tuple: InputIntervalTuple
  ): MinMaxValue<string> => {
    let newValue: MinMaxValue<string> = { min: '', max: '' };
    if (typeof tuple[1].min === 'string' && tuple[1].min.length > 0)
      newValue.min = unmaskValue(tuple[1].min);
    if (typeof tuple[1].max === 'string' && tuple[1].max.length > 0)
      newValue.max = unmaskValue(tuple[1].max);
    return newValue;
  };
  const validateInputs = (
    event: IEvent,
    v: { name: string; message: ValidationMessages },
    tuple: InputIntervalTuple,
    key: keyof MarketCycleInputIntervals
  ) => {
    const newValue = replaceCurrencyIfValid(tuple);
    if (Number(newValue.min) > Number(newValue.max)) {
      setValidation({ ...validation, [event.name]: v.message });
    } else if (!newValue.min && !newValue.max) {
      setValidation({
        ...validation,
        [`${key}min`]: false,
        [`${key}max`]: false,
      });
    } else {
      setValidation({
        ...validation,
        [`${key}min`]: false,
        [`${key}max`]: false,
      });
    }
  };

  const handleInput = (e: any, v: IResponse, tuple: MinMaxValue<string>) => {
    let newMinUsefulArea: string | number = 0;
    let newMaxUsefulArea: string | number = 0;
    if (v.name.includes('privateAreaIntervalmin')) {
      newMinUsefulArea = e.value.length > 0 ? e.value : 0;
      dispatch(
        setMinMaxAreaLocalFilters({ ...minMaxArea, min: newMinUsefulArea })
      );
    } else if (v.name.includes('privateAreaIntervalmax')) {
      newMaxUsefulArea = e.value.length > 0 ? e.value : 0;
      dispatch(
        setMinMaxAreaLocalFilters({ ...minMaxArea, max: newMaxUsefulArea })
      );
    }
    const typeNumber = e.name.includes('timeframe') ? 'int' : '';
    if (e.name.toLowerCase().includes('price')) {
      dispatch(handlePriceInputs(e, tuple));
    } else {
      dispatch(handleInputsIntervals(e, tuple, typeNumber));
    }
  };
  return (
    <div className="market-cycle__inputs-container__inputs row-container">
      <div>
        <Input
          cy={`${name}Min`}
          action={(e, v) => {
            handleInput(e, v, value);
          }}
          actionBlur={(e, v) => {
            validateInputs(e, { ...v, message: 'biggerThanMax' }, tuple, name);
          }}
          name={`${name}min`}
          placeholder={nls.initial}
          value={value.min}
          required={inputPatterns[`${name}min` as keyof MarketCycleInputs]}
          key={`${name}Min`}
        />
      </div>
      <div>
        <Input
          cy={`${name}Max`}
          action={(e, v) => handleInput(e, v, value)}
          actionBlur={(e, v) =>
            validateInputs(e, { ...v, message: 'smallerThanMin' }, tuple, name)
          }
          name={`${name}max`}
          placeholder={nls.final}
          value={value.max}
          required={inputPatterns[`${name}max` as keyof MarketCycleInputs]}
          key={`${name}Max`}
        />
      </div>
    </div>
  );
};

const MultiSelectButtons: React.FC<MultiSelectButtonsProps> = ({
  buttonsData,
  arrayName,
}: MultiSelectButtonsProps) => {
  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);
  const dispatch = useDispatch();
  const handleClickMultiSelect = (
    e: React.MouseEvent<HTMLButtonElement>,
    array: Array<TwoStateButton>,
    arrayName: string
  ) => {
    const newArray = array.map((el) =>
      el.name === e.currentTarget.name ? { ...el, selected: !el.selected } : el
    );
    const payload = {
      name: arrayName,
      value: newArray,
    };
    dispatch(updateMarketCycleFilters(payload));
  };

  return (
    <div className="buttons-container row-container">
      <span data-cy="ContainerTitleBedrooms">{nls.labels[arrayName]}</span>
      <div className="multiselect-buttons-container">
        {buttonsData.map((el: TwoStateButton, index: number) => (
          <Button
            className={`multi-select-button ${el.selected ? 'selected' : ''}`}
            cy={`BedroomsMultiSelect[${el.name}]`}
            name={el.name}
            key={`${arrayName} - ${el.name}`}
            onClick={(e) => handleClickMultiSelect(e, buttonsData, arrayName)}
          >
            {el.name}
          </Button>
        ))}
      </div>
    </div>
  );
};
export default MarketCycle;
